import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import blue from '@mui/material/colors/blue';

const useFormStyles = makeStyles((theme: Theme) =>
  createStyles({
    submitButton: {
      backgroundColor: blue[900],
      '&:hover': {
        backgroundColor: blue[800],
      },
      '&:active': {
        backgroundColor: blue[800],
      },
    },
  })
);
export default useFormStyles;
